"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LStoreApi = void 0;
const msgPack = __importStar(require("@thepowereco/msgpack"));
const _1 = require(".");
const codec = msgPack.createCodec({
    usemap: true,
});
const options = { codec };
const createPatch = (path, type, value) => {
    const th = Buffer.from('83C40174', 'hex');
    const tv = msgPack.encode(Buffer.from(new TextEncoder().encode(type)), options);
    const ph = Buffer.from('C40170', 'hex');
    const pv = msgPack.encode(path.map((i) => (typeof i === 'string' ? Buffer.from(new TextEncoder().encode(i)) : i)), options);
    const vh = Buffer.from('C40176', 'hex');
    const vv = msgPack.encode(typeof value === 'string' ? Buffer.from(new TextEncoder().encode(value)) : value, options);
    const res = Buffer.from([...th, ...tv, ...ph, ...pv, ...vh, ...vv]);
    return res;
};
const addItemToList = (path, itemValue) => createPatch(path, 'list_add', itemValue);
const deleteItemFromList = (path, itemValue) => createPatch(path, 'list_del', itemValue);
const deleteAllItemsFromList = (path) => createPatch(path, 'lists_cleanup', '');
const itemInList = (path, itemValue) => createPatch(path, 'member', itemValue);
const itemNotInList = (path, value) => createPatch(path, 'nonmember', value);
const addValue = (path, value) => createPatch(path, 'set', value);
const deleteValue = (path, value) => createPatch(path, 'delete', value);
const compareValue = (path, value) => createPatch(path, 'compare', value);
const existValue = (path, value) => createPatch(path, 'exist', value);
const nonExistValue = (path, value) => createPatch(path, 'nonexist', value);
const encodePatches = (patches) => {
    const mpatches = patches.reduce((a, it) => Buffer.from([...a, ...it]));
    const b1 = Buffer.from(new Uint16Array([patches.length]).buffer);
    const result = patches.length < 15
        ? Buffer.from([0x90 + patches.length, ...mpatches])
        : Buffer.from([0xdc, b1[1], b1[0], patches.length, ...mpatches]);
    return result;
};
const getLStore = async (address, path, key, network) => {
    let workNetwork = network;
    const addressChain = await network.getAddressChain(address);
    const addressChainNumber = addressChain?.chain;
    if (network.getChain() !== addressChainNumber) {
        workNetwork = new _1.NetworkApi(addressChainNumber);
        await workNetwork.bootstrap(network.getIsHTTPSNodesOnly());
    }
    return workNetwork.getLstoreData(address, path + key);
};
const setLStore = async (account, patches, network) => {
    let workNetwork = network;
    const addressChain = await network.getAddressChain(account.address);
    const addressChainNumber = addressChain?.chain;
    if (network.getChain() !== addressChainNumber) {
        workNetwork = new _1.NetworkApi(addressChainNumber);
        await workNetwork.bootstrap(network.getIsHTTPSNodesOnly());
    }
    const tx = await _1.TransactionsApi.composeStoreTX(account.address, patches, account.wif, workNetwork.feeSettings);
    return tx;
};
exports.LStoreApi = {
    addItemToList,
    deleteItemFromList,
    deleteAllItemsFromList,
    itemInList,
    itemNotInList,
    addValue,
    deleteValue,
    compareValue,
    existValue,
    nonExistValue,
    encodePatches,
    getLStore,
    setLStore,
};
